<template>
  <div id="app">
    <div id="head" class="head">
      <img :src="$specs ? $specs.logo : ''" alt="Logo" />
    </div>
    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
@font-face {
  font-family: Oswald;
  src: url("./assets/fonts/oswald/Oswald-VariableFont_wght.ttf");
}

body {
  font-size: 108% !important;
}

.container {
  max-width: 800px !important;
}

.form-control::selection {
  background: grey;
  color: white;
}
#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
}

.head {
  position: relative;
  margin: 0;
  margin-bottom: 30px;
  background-color: white;
  border-bottom: 43px solid lightgray;
  height: 120px;
  width: 100%;
}
.head img {
  position: absolute;
  top: 8px;
  left: 70px;
  height: 61px;
  width: auto;
  z-index: 1;
}

.content {
  margin-top: 50px;
}

.show-enter-active {
  animation: showoverlay 4.5s;
}
@keyframes showoverlay {
  0% {
    opacity: 0;
  }
  15% {
    opacity: 1;
  }
  85% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
